var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.html)?_c('div',{class:[{ '--no-padding': _vm.noPadding }, 'v-html'],domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }